/* ============================================================
   CLAIRENCE - Agrandissement des photos de la fiche produit
   Clic ou tap sur la photo principale : affichage plein ecran.
   Charge uniquement sur les pages produit (voir
   snippets/clairence-conversion.liquid). Aucune dependance.
   ============================================================ */
(function () {
  'use strict';

  var gallery = document.querySelector('.product-gallery');
  if (!gallery) return;
  var mainWrap = gallery.querySelector('.product-gallery__main');
  var mainImg = mainWrap && mainWrap.querySelector('img');
  if (!mainWrap || !mainImg) return;

  var BIG = 2000;                  /* largeur de l'image agrandie (px) */
  var box, stage, bigImg, counter, btnPrev, btnNext, btnClose;
  var items = [];
  var idx = 0;
  var startIdx = 0;
  var lastFocus = null;
  var zoomed = false;
  var loadToken = 0;
  var swallowClick = false;

  var ICON_ZOOM = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.5" y2="16.5"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
  var ICON_CLOSE = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg>';
  var ICON_PREV = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ICON_NEXT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  /* Remplace la largeur demandee a la CDN Shopify par une version plus grande. */
  function enlarge(url) {
    if (!url) return url;
    return /[?&]width=[0-9]+/.test(url)
      ? url.replace(/([?&])width=[0-9]+/, '$1width=' + BIG)
      : url;
  }

  /* Liste des photos visibles pour la couleur choisie (lue au moment du clic). */
  function collect() {
    var thumbs = Array.prototype.slice
      .call(gallery.querySelectorAll('.product-gallery__thumb'))
      .filter(function (t) { return !t.hidden; });

    items = thumbs.map(function (t) {
      var im = t.querySelector('img');
      return {
        thumb: t,
        src: t.getAttribute('data-src') || (im && im.src) || '',
        alt: (im && im.alt) || ''
      };
    });

    if (!items.length) {
      items = [{ thumb: null, src: mainImg.currentSrc || mainImg.src, alt: mainImg.alt || '' }];
      idx = 0;
      startIdx = 0;
      return;
    }

    idx = -1;
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i].thumb.classList.contains('is-active')) { idx = i; break; }
    }
    if (idx < 0) {
      for (i = 0; i < items.length; i++) {
        if (items[i].src && items[i].src === mainImg.getAttribute('src')) { idx = i; break; }
      }
    }
    if (idx < 0) idx = 0;
    startIdx = idx;
  }

  function build() {
    if (box) return;

    box = document.createElement('div');
    box.className = 'cl-zoom';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Photo agrandie');
    box.innerHTML =
      '<div class="cl-zoom__bar">' +
        '<span class="cl-zoom__count" aria-live="polite"></span>' +
        '<button type="button" class="cl-zoom__close" aria-label="Fermer">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="cl-zoom__stage">' +
        '<button type="button" class="cl-zoom__nav cl-zoom__nav--prev" aria-label="Photo precedente">' + ICON_PREV + '</button>' +
        '<img class="cl-zoom__img" alt="" draggable="false">' +
        '<button type="button" class="cl-zoom__nav cl-zoom__nav--next" aria-label="Photo suivante">' + ICON_NEXT + '</button>' +
      '</div>';
    document.body.appendChild(box);

    stage = box.querySelector('.cl-zoom__stage');
    bigImg = box.querySelector('.cl-zoom__img');
    counter = box.querySelector('.cl-zoom__count');
    btnPrev = box.querySelector('.cl-zoom__nav--prev');
    btnNext = box.querySelector('.cl-zoom__nav--next');
    btnClose = box.querySelector('.cl-zoom__close');

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); });

    /* Clic dans le fond sombre : fermeture. */
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === stage) close();
    });

    /* Zoom x2 a la souris (ordinateur uniquement). Sur mobile : pincer pour zoomer. */
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      bigImg.addEventListener('click', function (e) {
        e.stopPropagation();
        setZoom(!zoomed, e);
      });
      bigImg.addEventListener('mousemove', function (e) {
        if (zoomed) setOrigin(e);
      });
    } else {
      bigImg.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    /* Balayage au doigt pour changer de photo. */
    var sx = 0;
    var sy = 0;
    var single = false;
    stage.addEventListener('touchstart', function (e) {
      single = e.touches.length === 1;
      if (single) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!single || zoomed || items.length < 2) return;
      if (window.visualViewport && window.visualViewport.scale > 1.05) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        go(dx < 0 ? idx + 1 : idx - 1);
      }
    }, { passive: true });
  }

  function setOrigin(e) {
    var r = bigImg.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    bigImg.style.transformOrigin = x + '% ' + y + '%';
  }

  function setZoom(on, e) {
    zoomed = on;
    stage.classList.toggle('is-zoomed', on);
    if (on && e) setOrigin(e);
    if (!on) bigImg.style.transformOrigin = '';
  }

  function render() {
    var it = items[idx];
    var token = ++loadToken;
    var hi = enlarge(it.src);

    setZoom(false);
    bigImg.alt = it.alt;
    bigImg.src = it.src;   /* version 1000 px deja en cache : affichage immediat */
    box.classList.add('is-loading');

    if (hi === it.src) {
      box.classList.remove('is-loading');
    } else {
      var pre = new Image();
      pre.onload = function () {
        if (token !== loadToken) return;
        bigImg.src = hi;
        box.classList.remove('is-loading');
      };
      pre.onerror = function () {
        if (token !== loadToken) return;
        box.classList.remove('is-loading');
      };
      pre.src = hi;
    }

    var multi = items.length > 1;
    counter.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
    btnPrev.hidden = !multi;
    btnNext.hidden = !multi;

    if (multi) {
      /* Prechargement discret de la photo suivante. */
      (new Image()).src = enlarge(items[(idx + 1) % items.length].src);
    }
  }

  function go(i) {
    var n = items.length;
    if (n < 2) return;
    idx = (i + n) % n;
    render();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowLeft') {
      go(idx - 1);
    } else if (e.key === 'ArrowRight') {
      go(idx + 1);
    } else if (e.key === 'Tab') {
      /* Le focus reste dans la fenetre agrandie. */
      var f = Array.prototype.slice
        .call(box.querySelectorAll('button'))
        .filter(function (b) { return !b.hidden; });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function open() {
    collect();
    if (!items.length || !items[idx].src) return;
    build();
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('cl-zoom-lock');
    render();
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    btnClose.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    box.hidden = true;
    document.documentElement.classList.remove('cl-zoom-lock');
    document.removeEventListener('keydown', onKey);
    loadToken++;
    /* La galerie de la page affiche la photo qu'on regardait. */
    var it = items[idx];
    if (it && it.thumb && idx !== startIdx) it.thumb.click();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Bouton loupe (decouvrabilite, surtout sur mobile). */
  var hint = document.createElement('button');
  hint.type = 'button';
  hint.className = 'cl-zoom-hint';
  hint.setAttribute('aria-label', 'Agrandir la photo');
  hint.innerHTML = ICON_ZOOM;
  mainWrap.appendChild(hint);

  /* Clic sur la photo principale (hors fleches) : ouverture. */
  mainWrap.addEventListener('click', function (e) {
    if (e.target.closest('.product-gallery__arrow')) return;
    if (swallowClick) return;
    open();
  });

  /* Un balayage pour changer de photo ne doit pas ouvrir l'agrandissement. */
  var tx = 0;
  var ty = 0;
  mainWrap.addEventListener('touchstart', function (e) {
    tx = e.touches[0].clientX;
    ty = e.touches[0].clientY;
  }, { passive: true });
  mainWrap.addEventListener('touchend', function (e) {
    var t = e.changedTouches[0];
    if (Math.abs(t.clientX - tx) > 10 || Math.abs(t.clientY - ty) > 10) {
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 400);
    }
  }, { passive: true });
})();